import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import { Colors, ScriptFollowUpTypesV2, ScriptFollowUpV2 } from 'typings';
import MessageIcon from '@material-ui/icons/MessageRounded';
import PhoneIcon from '@material-ui/icons/Phone';
import VoicemailIcon from '@material-ui/icons/Voicemail';

interface ScriptStepFollowUpProps {
  isComplete: boolean;
  isFuture: boolean;
  isLast: boolean;
  scriptFollowUp: ScriptFollowUpV2;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    minHeight: '36px',
  },
  containerComplete: {
    filter: 'grayscale(1)',
    opacity: 0.4,
  },
  containerFuture: {
    filter: 'grayscale(0.5)',
    opacity: 0.7,
  },

  left: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(1),
    width: '20px',
  },
  bubble: {
    alignItems: 'center',
    borderRadius: '50%',
    color: Colors.WHITE,
    display: 'flex',
    height: '20px',
    justifyContent: 'center',
    width: '20px',
  },
  bubbleCall: {
    backgroundColor: Colors.GREEN,
  },
  bubbleMessage: {
    backgroundColor: theme.palette.secondary.main,
  },
  bubbleVoicemail: {
    backgroundColor: Colors.MEDIUM_GRAY,
  },
  icon: {
    fontSize: '0.8rem',
  },
  timeline: {
    background: theme.palette.primary.main,
    height: 'calc(100% - 28px)',
    marginBottom: '5px',
    marginTop: '3px',
    opacity: 0.3,
    width: '1px',
  },

  right: {
    paddingBottom: theme.spacing(2),
  },
  content: {
    whiteSpace: 'pre-wrap',
  },
  caption: {
    fontSize: '0.7rem',
    lineHeight: 2,
    opacity: 0.6,
  },
}));

const ScriptStepFollowUp = ({
  isComplete,
  isFuture,
  isLast,
  scriptFollowUp,
}: ScriptStepFollowUpProps) => {
  const styles = useStyles();

  return (
    <div
      className={cx(styles.container, {
        [styles.containerComplete]: isComplete,
        [styles.containerFuture]: isFuture,
      })}
    >
      <div className={styles.left}>
        <div
          className={cx(styles.bubble, {
            [styles.bubbleCall]: scriptFollowUp.type === ScriptFollowUpTypesV2.CALL,
            [styles.bubbleMessage]: scriptFollowUp.type === ScriptFollowUpTypesV2.MESSAGE,
            [styles.bubbleVoicemail]: scriptFollowUp.type === ScriptFollowUpTypesV2.VOICEMAIL,
          })}
        >
          {scriptFollowUp.type === ScriptFollowUpTypesV2.CALL && (
            <PhoneIcon className={styles.icon} />
          )}
          {scriptFollowUp.type === ScriptFollowUpTypesV2.MESSAGE && (
            <MessageIcon className={styles.icon} />
          )}
          {scriptFollowUp.type === ScriptFollowUpTypesV2.VOICEMAIL && (
            <VoicemailIcon className={styles.icon} />
          )}
        </div>
        {!isLast && <div className={styles.timeline}></div>}
      </div>
      <div className={styles.right}>
        {scriptFollowUp.messageText && (
          <div className={styles.content}>{scriptFollowUp.messageText}</div>
        )}
        {scriptFollowUp.voicemailName && (
          <div className={styles.content}>{scriptFollowUp.voicemailName}</div>
        )}
        <div className={styles.caption}>{scriptFollowUp.timingDelayFormatted}</div>
      </div>
    </div>
  );
};

export default ScriptStepFollowUp;
